import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import shoppingCartIcon from '../../assets/images/shopping-cart-icon.svg';

const BYOPTaxableCard = () => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      icon={shoppingCartIcon}
      title="Explore all T. Rowe Price® Mutual Fund"
      subtitle="A full range of investment strategies across multiple assest classes, capitalizations, sectors and styles."
      buttonText="View All Mutual Funds"
      buttonFunction={next('byop')}
      buttonID="btnTaxableBYOP"
    />
  );
};

export default BYOPTaxableCard;
